(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clothing-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-collection"]').forEach(initClothingCollection);
  });

  function initClothingCollection(root) {
    if (root.dataset.ccInit === 'true') return;
    root.dataset.ccInit = 'true';

    var sectionId = root.dataset.sectionId;
    var rootPath = root.dataset.rootUrl || '/';
    var cartAddUrl = root.dataset.cartAddUrl || rootPath + 'cart/add.js';
    var cartUrl = root.dataset.cartUrl || rootPath + 'cart';
    var scrim = root.querySelector('[data-panel-scrim]');

    function closeAllPanels() {
      root.querySelectorAll('[data-panel-body]').forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      if (scrim) {
        scrim.classList.remove('is-open');
        scrim.hidden = true;
      }
    }

    function openPanel(name) {
      var panel = root.querySelector('[data-panel-body="' + name + '"]');
      if (!panel) return;
      closeAllPanels();
      panel.classList.add('is-open');
      if (window.matchMedia('(max-width: 900px)').matches && scrim) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
        });
      }
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-panel-trigger]');
      if (trigger) {
        var name = trigger.dataset.panelTrigger;
        var panel = root.querySelector('[data-panel-body="' + name + '"]');
        if (panel && panel.classList.contains('is-open')) {
          closeAllPanels();
        } else {
          openPanel(name);
        }
        return;
      }

      if (e.target.closest('[data-panel-close]')) {
        closeAllPanels();
        return;
      }

      var clearBtn = e.target.closest('[data-clear-all]');
      if (clearBtn) {
        e.preventDefault();
        fetchAndApply(root.dataset.collectionUrl);
        return;
      }

      var chip = e.target.closest('[data-filter-link]');
      if (chip) {
        e.preventDefault();
        fetchAndApply(chip.getAttribute('href'));
        return;
      }
    });

    if (scrim) {
      scrim.addEventListener('click', closeAllPanels);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
    });

    document.addEventListener('click', function (e) {
      var sortWrap = root.querySelector('[data-panel-wrap="sort"]');
      var sortPanel = root.querySelector('[data-panel-body="sort"]');
      if (
        sortWrap &&
        sortPanel &&
        sortPanel.classList.contains('is-open') &&
        !sortWrap.contains(e.target) &&
        window.matchMedia('(min-width: 901px)').matches
      ) {
        closeAllPanels();
      }
    });

    var filterForm = root.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-filter-input]')) return;
        var params = new URLSearchParams(new FormData(filterForm));
        var sortInput = root.querySelector('[data-sort-input]:checked');
        if (sortInput) params.set('sort_by', sortInput.value);
        var url = root.dataset.collectionUrl + '?' + params.toString();
        fetchAndApply(url);
      });
    }

    root.querySelectorAll('[data-sort-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var params = new URLSearchParams(filterForm ? new FormData(filterForm) : '');
        params.set('sort_by', input.value);
        var url = root.dataset.collectionUrl + '?' + params.toString();
        fetchAndApply(url, function () {
          closeAllPanels();
        });
      });
    });

    function fetchAndApply(url, done) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          replacePart(doc, '[data-product-grid]');
          replacePart(doc, '[data-filter-form]');
          replacePart(doc, '[data-result-count]');
          replacePart(doc, '[data-filter-item-count]');
          replacePart(doc, '[data-filter-item-count-inline]');
          replacePart(doc, '[data-quick-filter]');

          var newClearButtons = doc.querySelectorAll('[data-clear-all]');
          root.querySelectorAll('[data-clear-all]').forEach(function (btn, i) {
            if (newClearButtons[i]) btn.hidden = newClearButtons[i].hidden;
          });

          var newDot = doc.querySelector('[data-filter-dot]');
          var dot = root.querySelector('[data-filter-dot]');
          if (dot && newDot) dot.hidden = newDot.hidden;

          history.replaceState({}, '', url);
          if (typeof done === 'function') done();
        })
        .catch(function (err) {
          console.error('Clothing collection filter/sort request failed:', err);
        });
    }

    function replacePart(doc, selector) {
      var current = root.querySelector(selector);
      var next = doc.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    }

    function showToast(html) {
      var toast = root.querySelector('[data-toast]');
      if (!toast) return;
      toast.innerHTML = html;
      toast.classList.add('is-visible');
      clearTimeout(toast._timeout);
      toast._timeout = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2600);
    }

    function updateCartCount(cart) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cb').forEach(function (b) {
        if (cart.item_count > 0) {
          b.textContent = cart.item_count;
          b.style.display = 'flex';
        } else {
          b.style.display = 'none';
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    }

    root.addEventListener('click', function (e) {
      var atcTrigger = e.target.closest('[data-atc-trigger]');
      if (atcTrigger) {
        var wrap = atcTrigger.closest('.ccc__atc-wrap');
        var picker = wrap ? wrap.querySelector('[data-size-picker]') : null;
        if (picker) picker.hidden = false;
        return;
      }

      if (e.target.closest('[data-size-close]')) {
        var closePicker = e.target.closest('[data-size-picker]');
        if (closePicker) closePicker.hidden = true;
        return;
      }

      var sizeBtn = e.target.closest('.ccc__size');
      if (sizeBtn && !sizeBtn.disabled) {
        var card = sizeBtn.closest('[data-product-card]');
        var atcButton = card ? card.querySelector('[data-atc-trigger]') : null;
        var picker2 = sizeBtn.closest('[data-size-picker]');
        var variantId = sizeBtn.dataset.variantId;
        var variantTitle = sizeBtn.dataset.variantTitle;
        var productTitle = card ? card.dataset.productTitle : 'Item';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            return fetch(rootPath + 'cart.js').then(function (res) {
              return res.json();
            });
          })
          .then(function (cart) {
            updateCartCount(cart);
            if (picker2) picker2.hidden = true;
            if (atcButton) {
              atcButton.dataset.state = 'added';
              atcButton.textContent = 'Added · ' + variantTitle;
              setTimeout(function () {
                atcButton.textContent = 'Add to bag';
                delete atcButton.dataset.state;
              }, 2000);
            }
            showToast(
              productTitle + ', ' + variantTitle + ' added <a href="' + cartUrl + '">View bag</a>'
            );
          })
          .catch(function (err) {
            console.error('Clothing collection add-to-cart error:', err);
            showToast('Could not add item to bag.');
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-hero').forEach(initClothingHero);
  });

  function initClothingHero(root) {
    var track = root.querySelector('[data-hero-track]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var slides = track ? track.querySelectorAll('.cl-hero__slide') : [];
    if (!track || slides.length < 2) return;

    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      var slide = slides[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.heroDot, 10));
        restart();
      });
    });

    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    });

    function tick() {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      var next = (index + 1) % slides.length;
      goTo(next);
    }

    function start() {
      if (!autoplay || reduceMotion) return;
      timer = setInterval(tick, speed);
    }

    function restart() {
      clearInterval(timer);
      start();
    }

    track.addEventListener('pointerdown', function () {
      clearInterval(timer);
    });
    track.addEventListener('pointerup', restart);

    start();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-rail').forEach(initClothingRail);
  });

  function initClothingRail(root) {
    if (root.dataset.railInit === 'true') return;
    root.dataset.railInit = 'true';

    var rootPath = root.dataset.rootUrl || '/';
    var cartAddUrl = root.dataset.cartAddUrl || rootPath + 'cart/add.js';
    var cartUrl = root.dataset.cartUrl || rootPath + 'cart';

    function updateCartCount(cart) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cb').forEach(function (b) {
        if (cart.item_count > 0) {
          b.textContent = cart.item_count;
          b.style.display = 'flex';
        } else {
          b.style.display = 'none';
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    }

    root.addEventListener('click', function (e) {
      var atcTrigger = e.target.closest('[data-atc-trigger]');
      if (atcTrigger) {
        var wrap = atcTrigger.closest('.ccc__atc-wrap');
        var picker = wrap ? wrap.querySelector('[data-size-picker]') : null;
        if (picker) picker.hidden = false;
        return;
      }

      if (e.target.closest('[data-size-close]')) {
        var closePicker = e.target.closest('[data-size-picker]');
        if (closePicker) closePicker.hidden = true;
        return;
      }

      var sizeBtn = e.target.closest('.ccc__size');
      if (sizeBtn && !sizeBtn.disabled) {
        var card = sizeBtn.closest('[data-product-card]');
        var atcButton = card ? card.querySelector('[data-atc-trigger]') : null;
        var picker2 = sizeBtn.closest('[data-size-picker]');
        var variantId = sizeBtn.dataset.variantId;
        var variantTitle = sizeBtn.dataset.variantTitle;

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            return fetch(rootPath + 'cart.js').then(function (res) {
              return res.json();
            });
          })
          .then(function (cart) {
            updateCartCount(cart);
            if (picker2) picker2.hidden = true;
            if (atcButton) {
              atcButton.dataset.state = 'added';
              atcButton.textContent = 'Added · ' + variantTitle;
              setTimeout(function () {
                atcButton.textContent = 'Add to bag';
                delete atcButton.dataset.state;
              }, 2000);
            }
          })
          .catch(function (err) {
            console.error('Clothing landing rail add-to-cart error:', err);
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-quiz"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-quiz').forEach(initClothingQuiz);
  });

  function initClothingQuiz(root) {
    var answers = {};
    var steps = root.querySelectorAll('[data-quiz-step]');
    var segs = root.querySelectorAll('[data-quiz-seg]');
    var result = root.querySelector('[data-quiz-result]');
    var body = root.querySelector('.cl-quiz__body');

    function showStep(index) {
      steps.forEach(function (step) {
        step.classList.toggle('is-active', parseInt(step.dataset.quizStep, 10) === index);
      });
      segs.forEach(function (seg) {
        var segIndex = parseInt(seg.dataset.quizSeg, 10);
        seg.classList.toggle('is-active', segIndex === index);
        seg.classList.toggle('is-done', segIndex < index);
      });
    }

    function computeFabric() {
      if (answers.need === 'soft') return 'modal';
      if (answers.need === 'air') return answers.season === 'cool' ? 'pointelle' : 'muslin';
      if (answers.need === 'wear') return 'pointelle';
      return answers.season === 'warm' ? 'muslin' : 'modal';
    }

    function showResult() {
      var key = computeFabric();
      steps.forEach(function (step) {
        step.classList.remove('is-active');
      });
      if (body) body.querySelector('[data-quiz-bar]').hidden = true;
      root.querySelectorAll('[data-fabric-key]').forEach(function (card) {
        card.hidden = card.dataset.fabricKey !== key;
      });
      if (result) result.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var option = e.target.closest('[data-question]');
      if (option) {
        answers[option.dataset.question] = option.dataset.value;
        var currentStep = option.closest('[data-quiz-step]');
        var currentIndex = parseInt(currentStep.dataset.quizStep, 10);

        setTimeout(function () {
          if (currentIndex < steps.length - 1) {
            showStep(currentIndex + 1);
          } else {
            showResult();
          }
        }, 220);
        return;
      }

      if (e.target.closest('[data-quiz-reset]')) {
        answers = {};
        if (result) result.hidden = true;
        var bar = root.querySelector('[data-quiz-bar]');
        if (bar) bar.hidden = false;
        showStep(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp-lab-test-report"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lab-test-modal]').forEach(function (modal) {
      document.addEventListener('clothing-pdp:open-lab-test', function () {
        modal.hidden = false;
      });
      modal.querySelectorAll('[data-lab-test-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          modal.hidden = true;
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-lab-test-modal]:not([hidden])').forEach(function (modal) {
        modal.hidden = true;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-pdp-tabs').forEach(initClothingPdpTabs);
  });

  function initClothingPdpTabs(root) {
    var triggers = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    var barWrap = root.querySelector('[data-tabs-bar-wrap]');

    function setActive(name) {
      triggers.forEach(function (t) {
        var active = t.dataset.tabTrigger === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function scrollToPanel(name) {
      var panel = root.querySelector('[data-tab-panel="' + name + '"]');
      if (!panel) return;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(name);
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () { scrollToPanel(t.dataset.tabTrigger); });
    });

    document.addEventListener('clothing-pdp:open-tab', function (e) {
      scrollToPanel(e.detail.tab);
    });

    // Scrollspy: highlight the tab whose panel is currently most in view.
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(entry.target.dataset.tabPanel);
            }
          });
        },
        { rootMargin: '-20% 0px -60% 0px', threshold: 0.01 }
      );
      panels.forEach(function (panel) { observer.observe(panel); });
    }

    // Sticky shadow once the tab bar reaches the top of the viewport.
    if (barWrap) {
      var toggleStuck = function () {
        barWrap.classList.toggle('is-stuck', barWrap.getBoundingClientRect().top <= 0);
      };
      window.addEventListener('scroll', toggleStuck, { passive: true });
      toggleStuck();
    }

    root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.cl-pdp-faq__item').classList.toggle('is-open');
      });
    });

    initFitFinder(root);
  }

  function initFitFinder(root) {
    var finder = root.querySelector('[data-fit-finder]');
    if (!finder) return;

    var ageWrap = finder.querySelector('[data-finder-age]');
    var ageOptions = (finder.dataset.ageOptions || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var sizeTable = (finder.dataset.sizeTable || '').split('\n').map(function (row) {
      var parts = row.split('|').map(function (s) { return s.trim(); });
      return { label: parts[0], min: parseFloat(parts[1]), max: parseFloat(parts[2]) };
    }).filter(function (row) { return row.label; });

    var selectedAge = ageOptions[0] || '';
    ageOptions.forEach(function (age, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cl-pdp-finder__seg' + (i === 0 ? ' is-active' : '');
      btn.dataset.value = age;
      btn.textContent = age;
      btn.addEventListener('click', function () {
        ageWrap.querySelectorAll('.cl-pdp-finder__seg').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedAge = age;
      });
      ageWrap.appendChild(btn);
    });

    var weightInput = finder.querySelector('[data-finder-weight]');
    var weightLabel = finder.querySelector('[data-finder-weight-label]');
    var selectedWeight = parseFloat(weightInput.value);
    weightInput.addEventListener('input', function () {
      selectedWeight = parseFloat(weightInput.value);
      weightLabel.textContent = selectedWeight + ' kg';
    });

    var selectedBody = 'average';
    finder.querySelector('[data-finder-body]').querySelectorAll('.cl-pdp-finder__seg').forEach(function (btn) {
      btn.addEventListener('click', function () {
        finder.querySelectorAll('[data-finder-body] .cl-pdp-finder__seg').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedBody = btn.dataset.value;
      });
    });

    finder.querySelector('[data-finder-submit]').addEventListener('click', function () {
      var adjustedWeight = selectedWeight;
      if (selectedBody === 'slim') adjustedWeight -= 0.8;
      if (selectedBody === 'cuddly') adjustedWeight += 0.8;

      var match = sizeTable.find(function (row) {
        return adjustedWeight >= row.min && adjustedWeight <= row.max;
      }) || sizeTable[sizeTable.length - 1];

      if (!match) return;

      var result = finder.querySelector('[data-finder-result]');
      var sizeEl = finder.querySelector('[data-finder-result-size]');
      var whyEl = finder.querySelector('[data-finder-result-why]');
      var marker = finder.querySelector('[data-finder-fit-marker]');

      sizeEl.textContent = match.label;
      whyEl.textContent = 'Based on ' + selectedWeight + ' kg and a ' + selectedBody + ' build, this gives room to grow without swamping them.';

      var range = match.max - match.min;
      var position = range > 0 ? (adjustedWeight - match.min) / range : 0.5;
      position = Math.max(0.08, Math.min(0.92, position));
      marker.style.left = (position * 100) + '%';

      result.hidden = false;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(initClothingPdp);
  });

  function initClothingPdp(root) {
    if (root.dataset.pdpInit === 'true') return;
    root.dataset.pdpInit = 'true';

    initGallery(root);
    initStickyBar(root);
    initCartHelpers(root);
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    var count = root.querySelector('[data-gallery-count]');
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      if (count) count.textContent = index + 1 + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.dataset.index, 10));
      });
    });

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    root.querySelectorAll('[data-jump-to-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('clothing-pdp:open-tab', { detail: { tab: btn.dataset.jumpToTab } }));
      });
    });
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-sticky-bar]');
    var anchor = root.querySelector('[data-atc-trigger]') || root.querySelector('.cl-pdp__gallery');
    if (!bar || !anchor) return;

    function updateVisibility() {
      if (window.matchMedia('(max-width: 900px)').matches) {
        bar.classList.add('on');
        return;
      }
      var rect = anchor.getBoundingClientRect();
      bar.classList.toggle('on', rect.bottom < 0);
    }

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.matchMedia('(max-width: 900px)').matches) {
            bar.classList.add('on');
            return;
          }
          bar.classList.toggle('on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      });
      observer.observe(anchor);
    } else {
      window.addEventListener('scroll', updateVisibility, { passive: true });
    }
    updateVisibility();

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-atc]')) {
        var mainAtc = root.querySelector('[data-atc-trigger]');
        if (mainAtc) mainAtc.click();
      }
    });
  }

  function clothingPdpAddToCartAjax(root, items) {
    var rootPath = root.dataset.rootUrl || '/';
    var cartAddUrl = root.dataset.cartAddUrl || rootPath + 'cart/add.js';
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to add items to cart.');
        return response.json();
      })
      .then(function (data) {
        return fetch(rootPath + 'cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cb').forEach(function (b) {
              if (cart.item_count > 0) {
                b.textContent = cart.item_count;
                b.style.display = 'flex';
              } else {
                b.style.display = 'none';
              }
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            if (window.theme && window.theme.CartDrawer) {
              try { new window.theme.CartDrawer(); } catch (e) {}
            }
            clothingPdpToast(root, 'Added to bag successfully!');
            return cart;
          });
      })
      .catch(function (err) {
        console.error('Clothing PDP add-to-cart error:', err);
        clothingPdpToast(root, 'Error adding product(s) to cart.');
      });
  }

  function clothingPdpToast(root, message) {
    var toast = document.querySelector('[data-clothing-pdp-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-clothing-pdp-toast', '');
      toast.className = 'cl-pdp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function clothingPdpFormatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return currency + ' ' + amount;
    }
  }

  function initCartHelpers(root) {
    window.clothingPdpAddToCartAjax = window.clothingPdpAddToCartAjax || clothingPdpAddToCartAjax;
    window.clothingPdpToast = window.clothingPdpToast || clothingPdpToast;
    window.clothingPdpFormatMoney = window.clothingPdpFormatMoney || clothingPdpFormatMoney;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
